module.exports = [
    'غالبا از توجه کافی به جزئیات در می‌ماند یا در کار تحصیلی، کار با سایر فعالیت‌ها اشتباهات ناشی از بی دقتی مرتکب می‌شود',
    'غالبا دست و پاهایش بیقرار است و روی صندلی وول می‌خورد',
    'غالبا از حفظ توجه بر روی تکالیف یا فعالیت‌های مربوط به بازی‌ها ناتوان است',
    'غالبا در کلاس یا جاهای دیگری که انتظار می‌رود شخص نشسته باقی بماند، صندلی خود را ترک می‌کند',
    'غالبا به نظر می‌رسد وقتی مستقیما با او صحبت شود گوش نمی‌دهد',
    'در جاهایی که مناسبتی ندارد می‌رود یا از در و دیوار بالا می‌رود',
    'غالبا دستورالعمل‌ها را کامل اجرا نمی‌کند، کار درسی، وظایف و تکالیف محیط کار را تکمیل نمی‌کند',
    'غالبا در اشتغال بی سر و صدا به فعالیت‌های تفریحی و بازی ناتوان است',
    'غالبا در سازماندهی تکالیف و فعالیت‌ها ناتوان است',
    'غالبا در حال حرکت است و به نظر می‌رسد "موتوری به حرکتش وا می‌دارد"',
    'از تکالیفی که نیازمند فعالیت ذهنی مستمر است اجتناب می‌کند یا نفرت دارد یا در اقدام به آن مردد است (مثل کاردستی یا تکالیف خانگی)',
    'غالبا زیاد حرف می‌زند',
    'غالبا اشیاء لازم برای انجام تکالیف و فعالیت‌ها را گم می‌کند (مثل تکالیف درسی، مداد، کتاب و وسایل آموزشی)',
    'غالبا قبل از اینکه سوال تمام شود، جواب‌هایی می‌پراند',
    'محرک‌های بیرونی غالبا حواسش را به آسانی پرت می‌کند',
    'غالبا در انتظار کشیدن برای نوبت ناتوان است',
    'در فعالیت‌های روزمره غالبا فراموشکار است',
    'غالبا حرف دیگران را قطع کرده یا مداخله می‌کند'
]